export default __webpack_public_path__ + "static/media/PalliativeCarev4220503PalliativecareguidelineV4_flowchart.3b5891b8.jpg";